
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { DateTime } from 'luxon';

@Component<CreditsInfo>({})
export default class CreditsInfo extends Vue {
	@Getter('getRestaurantName', { namespace: 'restaurant' }) private restaurantName!: string;
	@Prop({ type: Object, required: true }) private credits!: CreditsUserInfo;
	@Prop({ type: Boolean, required: false, default: true }) private active!: boolean;

	/**
	 * Expiry date of the credits if applicable.
	 *
	 * @return {string | null}
	 */
	private get expiryDate(): string | null {
		if (!this.credits.expiry) {
			return null;
		}
		return DateTime.fromISO(this.credits.expiry).toFormat(this.$t('credits.date_format'));
	}
}
